
/*  CERTIFICATE */
export const CERTIFICATE_UPLOAD = 'CERTIFICATE_UPLOAD';
export const CERTIFICATE_UPLOAD_ERROR = 'CERTIFICATE_UPLOAD_ERROR';
export const CERTIFICATE_UPLOAD_START = 'CERTIFICATE_UPLOAD_START';
export const CERTIFICATE_DROPPED = 'CERTIFICATE_DROPPED';
export const CERTIFICATE_SUBMIT_FORM = "CERTIFICATE_SUBMIT_FORM";
export const CERTIFICATE_INIT = "CERTIFICATE_INIT";
export const CLIENTSECRET_INIT = "CLIENTSECRET_INIT";
export const SELECTRIZIV = "SELECTRIZIV";
/*  AUTHENTICATION */
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_USERINFO_RETRIEVED = 'AUTHENTICATION_USERINFO_RETRIEVED';
export const AUTHENTICATION_LOGIN_COMPLETED_SUCCESS = 'AUTHENTICATION_LOGIN_COMPLETED_SUCCESS';
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT';
export const AUTHENTICATION_ERRORMESSAGE = 'AUTHENTICATION_ERRORMESSAGE';
export const AUTHENTICATION_SET_USERNAME = 'AUTHENTICATION_SET_USERNAME';
export const AUTHENTICATION_SET_PASSWORD = 'AUTHENTICATION_SET_PASSWORD'
